import React from 'react';
import { FormattedMessage } from 'react-intl';
import utils from '../../utils/utils';

const AdminRoutePlanV2RouteSetupPickupSlotDisplay = ({ pickupSlot }) => {
  return (
    <>
      <div>
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.details.name'} />
        </strong>
        : {pickupSlot.name}
      </div>
      <div>
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.details.start.depot'} />
        </strong>
        : {pickupSlot.startDepot ? `${pickupSlot.startDepot.name} (#${pickupSlot.startDepot.id})` : '-'}
      </div>
      <div>
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.details.pickup.time'} />
        </strong>
        :{' '}
        {pickupSlot.fromHour
          ? utils.getFormattedTimeRange(
              pickupSlot.fromHour,
              pickupSlot.fromMinutes,
              pickupSlot.toHour,
              pickupSlot.toMinutes
            )
          : utils.getFormattedDateRangeFromStrings(pickupSlot.pickupFrom, pickupSlot.pickupTo, false)}
      </div>
      <div>
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.details.vehicles'} />
        </strong>
        :{' '}
      </div>
      <table className="table table-striped admin__table m-b-6">
        <thead>
          <tr>
            <th scope="col">Vehicle ID</th>
            <th scope="col">Count</th>
            <th scope="col">Capacity</th>
            <th scope="col">Max travel time</th>
            <th scope="col">Max late time</th>
            <th scope="col">Late constant</th>
          </tr>
        </thead>
        <tbody>
          {pickupSlot.vehicles.map((vehicle) => (
            <tr key={vehicle.vehicleId}>
              <td>{vehicle.vehicleId}</td>
              <td>{vehicle.count}</td>
              <td>{vehicle.capacity}</td>
              <td>{vehicle.maxTravelTimeInMinutes || '-'}</td>
              <td>{vehicle.maxLateTimeInMinutes || '-'}</td>
              <td>{vehicle.routingProfileName || '-'}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div>
        <strong>
          <FormattedMessage id={'admin.route.plan.setups.setup.field.pickup.slot.details.route.plan'} />
        </strong>
        : {pickupSlot.routePlanId ? `#${pickupSlot.routePlanId}` : '-'}
      </div>
    </>
  );
};

export default AdminRoutePlanV2RouteSetupPickupSlotDisplay;
